mod.modules.define("InsiderDecisions", "BaseModule", function(fn) {
	"use strict";

	var cache = {
		$table: null,
		$selectName: null,
		$selectTransaction: null,
		$viewMore: null
	};

	fn.prototype.init = function (params) {
		this.base("init", params);
		this.size = this.el.data("size");

		// Cache
		cache.$table = this.el.find("table.data");
		cache.$selectName = this.el.find("select.insider-select-name");
		cache.$selectTransaction = this.el.find("select.insider-select-transaction");
		cache.$viewMore = this.el.find("a.module-expand-link");

		if (this.size == "4") {
			this.initPaging(cache.$table);
		}
	};

	fn.prototype.initPaging = function ($el) {
		$el.paginateTable({
			rowsPerPage: 17,
			nextPage: "a[data-action=next]",
			prevPage: "a[data-action=prev]",
			totalPages: ".pageCount",
			pager: ".insiderdecisions-paging .pager-wrap",
			autoHidePager: false
		});
	};

	fn.prototype.updateInsiders = function (response) {
		if (response.html) {
			var table = this.el.find("div.insider-tablewrapper");
			table.replaceWith(response.html);

			//bind events
			var newTable = this.el.find("table.data");

			newTable.find("tbody a[rel=tooltip]").tooltip();

			if (this.size == "4") {
				this.initPaging(newTable);
			}
		}
	};

	fn.prototype.events = {
		".scroll-chiclet:not(.selected)": {
			"click": function (e, $el) {
				// Scroll to the new index
				var index = parseInt($el.attr("data-index"), 10);

				var $tableBodies = this.el.find("table.data tbody");

				// Show the correct tbody
				$tableBodies.hide();
				$tableBodies.eq(index).show();

				// Highlight this chiclet
				$el.siblings().removeClass("selected");
				$el.addClass("selected");

				//show view more
				if (index == "3") {
					cache.$viewMore.show();
				} else {
					cache.$viewMore.hide();
				}
			}
		},
		"button:not(.active)": {
			"click": function (e, $el) {
				var currentType = $el.attr("data-type");
				var value = $el.attr("data-action");

				var loadData = {};

				if (currentType == "transaction") {
					loadData.TransactionType = value;
				}

				if (currentType == "timeframe") {
					loadData.AmountOfHistory = value;
				}

				if (value != "download") {
				    this.reload(loadData);
				}
			}
		},
		"select": {
		    "change": function (e, $el) {
				var self = this;

				var loadData = {
					InsiderNameFilter: cache.$selectName.val(),
					TransactionTypeFilter: cache.$selectTransaction.val()
				};

				this.ajax(loadData, function (response) { self.updateInsiders(response); });
			}
		}
	};

});

